"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class Organisation extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'organisation';
        this._orgCurrency = initParams.org_currency;
        this._name = initParams.name;
        this._websiteUrl = initParams.website_url;
        this._contactEmail = initParams.contact_email;
        this._contactPhone = initParams.contact_phone;
        this._address = initParams.address;
        this._mfaEnforced = initParams.mfa_enforced;
        this._orgEmailAddress = (0, util_1.camelArray)(initParams.org_email_address);
        this._emailAddress = initParams.email_address;
        this._vatId = initParams.vat_id;
        this._tour = initParams.tour;
        this._free = initParams.free;
        this._acceptedTerms = initParams.accepted_terms;
        this._defaultOccupancySchedule = initParams.default_occupancy_schedule;
        this._whiteLabel = initParams.white_label;
        this._inheritWhiteLabelFrom = initParams.inherit_white_label_from;
        this._whiteLabelTheme = initParams.white_label_theme;
        this._customDomainUrl = initParams.custom_domain_url;
        this._whiteLabelCustomTheme = initParams.white_label_custom_theme;
        this._defaultModifiers = initParams.default_modifiers;
    }
    set orgCurrency(value) {
        console.error('Do not set objects this way');
    }
    setOrgCurrency(value) {
        return this.dataService.updateOrganisation(this.id, { org_currency: value }, this);
    }
    get orgCurrency() {
        return this._orgCurrency;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    setName(value) {
        return this.dataService.updateOrganisation(this.id, { name: value }, this);
    }
    get name() {
        return this._name;
    }
    set websiteUrl(value) {
        console.error('Do not set objects this way');
    }
    setWebsiteUrl(value) {
        return this.dataService.updateOrganisation(this.id, { website_url: value }, this);
    }
    get websiteUrl() {
        return this._websiteUrl;
    }
    set contactEmail(value) {
        console.error('Do not set objects this way');
    }
    setContactEmail(value) {
        return this.dataService.updateOrganisation(this.id, { contact_email: value }, this);
    }
    get contactEmail() {
        return this._contactEmail;
    }
    set contactPhone(value) {
        console.error('Do not set objects this way');
    }
    setContactPhone(value) {
        return this.dataService.updateOrganisation(this.id, { contact_phone: value }, this);
    }
    get contactPhone() {
        return this._contactPhone;
    }
    set address(value) {
        console.error('Do not set objects this way');
    }
    setAddress(value) {
        return this.dataService.updateOrganisation(this.id, { address: value }, this);
    }
    get address() {
        return this._address;
    }
    set mfaEnforced(value) {
        console.error('Do not set objects this way');
    }
    setMfaEnforced(value) {
        return this.dataService.updateOrganisation(this.id, { mfa_enforced: value }, this);
    }
    get mfaEnforced() {
        return this._mfaEnforced;
    }
    set orgEmailAddress(value) {
        console.error('Do not set objects this way');
    }
    setOrgEmailAddress(value) {
        return this.dataService.updateOrganisation(this.id, { org_email_address: (0, util_1.snakeArray)(value) }, this);
    }
    get orgEmailAddress() {
        return this._orgEmailAddress;
    }
    set emailAddress(value) {
        console.error('Do not set objects this way');
    }
    setEmailAddress(value) {
        return this.dataService.updateOrganisation(this.id, { email_address: value }, this);
    }
    get emailAddress() {
        return this._emailAddress;
    }
    set vatId(value) {
        console.error('Do not set objects this way');
    }
    setVatId(value) {
        return this.dataService.updateOrganisation(this.id, { vat_id: value }, this);
    }
    get vatId() {
        return this._vatId;
    }
    set tour(value) {
        console.error('Do not set objects this way');
    }
    setTour(value) {
        return this.dataService.updateOrganisation(this.id, { tour: value }, this);
    }
    get tour() {
        return this._tour;
    }
    set free(value) {
        console.error('Do not set objects this way');
    }
    setFree(value) {
        return this.dataService.updateOrganisation(this.id, { free: value }, this);
    }
    get free() {
        return this._free;
    }
    set acceptedTerms(value) {
        console.error('Do not set objects this way');
    }
    setAcceptedTerms(value) {
        return this.dataService.updateOrganisation(this.id, { accepted_terms: value }, this);
    }
    get acceptedTerms() {
        return this._acceptedTerms;
    }
    set defaultOccupancySchedule(value) {
        console.error('Do not set objects this way');
    }
    setDefaultOccupancySchedule(value) {
        return this.dataService.updateOrganisation(this.id, { default_occupancy_schedule: value }, this);
    }
    get defaultOccupancySchedule() {
        return this._defaultOccupancySchedule;
    }
    set whiteLabel(value) {
        console.error('Do not set objects this way');
    }
    setWhiteLabel(value) {
        return this.dataService.updateOrganisation(this.id, { white_label: value }, this);
    }
    get whiteLabel() {
        return this._whiteLabel;
    }
    set inheritWhiteLabelFrom(value) {
        console.error('Do not set objects this way');
    }
    setInheritWhiteLabelFrom(value) {
        return this.dataService.updateOrganisation(this.id, { inherit_white_label_from: value }, this);
    }
    get inheritWhiteLabelFrom() {
        return this._inheritWhiteLabelFrom;
    }
    set whiteLabelTheme(value) {
        console.error('Do not set objects this way');
    }
    setWhiteLabelTheme(value) {
        return this.dataService.updateOrganisation(this.id, { white_label_theme: value }, this);
    }
    get whiteLabelTheme() {
        return this._whiteLabelTheme;
    }
    set customDomainUrl(value) {
        console.error('Do not set objects this way');
    }
    setCustomDomainUrl(value) {
        return this.dataService.updateOrganisation(this.id, { custom_domain_url: value }, this);
    }
    get customDomainUrl() {
        return this._customDomainUrl;
    }
    set whiteLabelCustomTheme(value) {
        console.error('Do not set objects this way');
    }
    setWhiteLabelCustomTheme(value) {
        return this.dataService.updateOrganisation(this.id, { white_label_custom_theme: value }, this);
    }
    get whiteLabelCustomTheme() {
        return this._whiteLabelCustomTheme;
    }
    set defaultModifiers(value) {
        console.error('Do not set objects this way');
    }
    setDefaultModifiers(value) {
        return this.dataService.updateOrganisation(this.id, { default_modifiers: value }, this);
    }
    get defaultModifiers() {
        return this._defaultModifiers;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateOrganisation(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
}
exports.default = Organisation;
//# sourceMappingURL=organisation.js.map